import {
    ClipboardPlus, Droplet, ScanSearch, Waves, Ruler, ChartPie, Stethoscope, Salad,
    Sparkles, Venus, Activity, Footprints, Bone, Accessibility, Dumbbell, HeartPulse, ClipboardList,
} from 'lucide-react';

/**
 * areeProfilo — le linguette del Profilo medico, DERIVATE dalle schede
 * attive, non scritte a mano.
 *
 * Fino al 22 settembre 2026 ogni scheda di schede_struttura era una riga
 * scritta in PazienteDetail: la cardiologia e' stata attiva e invisibile
 * per tre ore perche' nessuno aveva aggiunto la riga. Adesso
 * /api/schede/profilo/:id dice quali schede sono attive - con codice,
 * nome, area e ordine - e le voci nascono da li'. Quello che resta
 * scritto a mano e' solo COME disegnarle: il titolo del gruppo per
 * un'area (ortopedia, fisiatria e fisioterapia insieme; la medicina
 * estetica sotto Pelle) e l'icona. Un'area nuova senza una riga qui
 * esce col suo nome e un'icona generica: visibile, non sparita.
 *
 * Le quattro schede nate dai questionari (pelle, tricologia, misure,
 * composizione), il profilo alimentare e la gastroenterologica non
 * stanno in schede_struttura come le altre: restano fisse.
 */
const GRUPPO_DI_AREA = {
    estetica: 'Pelle',
    funzione_motoria: 'Ortopedia / Fisiatria / Fisioterapia',
    ortopedia: 'Ortopedia / Fisiatria / Fisioterapia',
    fisiatria: 'Ortopedia / Fisiatria / Fisioterapia',
    fisioterapia: 'Ortopedia / Fisiatria / Fisioterapia',
};
const ICONA_DI_AREA = {
    estetica: Sparkles, ginecologia: Venus, ortopedia: Bone, fisiatria: Accessibility,
    fisioterapia: Dumbbell, funzione_motoria: Activity, cardiologia: HeartPulse,
};
const ICONA_DI_SCHEDA = { scheda_cammino_autonomia: Footprints };

const AREE_FISSE = () => [
    { titolo: 'Anamnesi', voci: [{ id: 'anamnesi', label: 'Anamnesi', icon: ClipboardPlus }] },
    /* Esami sta accanto ad Anamnesi e non in fondo: sono le due che si
       aprono per prime su qualunque paziente. */
    { titolo: 'Esami', voci: [{ id: 'sangue', label: 'Esami e Referti', icon: Droplet }] },
    { titolo: 'Pelle', voci: [
        { id: 'pelle',       label: 'Analisi della Pelle', icon: ScanSearch },
        { id: 'tricologico', label: 'Esame Tricologico',   icon: Waves },
    ] },
    { titolo: 'Nutrizione / Gastro', voci: [
        { id: 'misure',       label: 'Misure Corporee / BMI',         icon: Ruler },
        { id: 'composizione', label: 'Analisi Composizione Corporea', icon: ChartPie },
        { id: 'gastro',       label: 'Scheda Gastroenterologica',     icon: Stethoscope },
        { id: 'alimentare',   label: 'Profilo Alimentare',            icon: Salad },
    ] },
];

/**
 * @param {Array} schede  da /api/schede/profilo/:id: { codice, nome, area_codice, area_nome, ordine }
 * @returns {Array} [{ titolo, voci: [{ id, label, icon }] }]
 */
export function areeProfilo(schede) {
    const aree = AREE_FISSE();
    const ordinate = [...(schede || [])].sort((a, b) => (a.ordine ?? 0) - (b.ordine ?? 0) || String(a.nome).localeCompare(String(b.nome)));
    for (const sch of ordinate) {
        const titolo = GRUPPO_DI_AREA[sch.area_codice] || sch.area_nome || 'Altre schede';
        let gruppo = aree.find((a) => a.titolo === titolo);
        if (!gruppo) { gruppo = { titolo, voci: [] }; aree.push(gruppo); }
        gruppo.voci.push({
            id: sch.codice,
            label: sch.nome,
            icon: ICONA_DI_SCHEDA[sch.codice] || ICONA_DI_AREA[sch.area_codice] || ClipboardList,
        });
    }
    return aree;
}
